import { render } from "./ToolConfigForm.vue?vue&type=template&id=37ff8b40&scoped=true"
import script from "./ToolConfigForm.vue?vue&type=script&lang=js"
export * from "./ToolConfigForm.vue?vue&type=script&lang=js"

import "./ToolConfigForm.vue?vue&type=style&index=0&id=37ff8b40&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ff8b40"]])

export default __exports__